<template>
  <validation-observer ref="observer">
    <form role="form">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <base-input
              v-model="fuelTransactionForm.license_plate"
              placeholder=""
              label="Placa"
              :required="true"
            >
              <template v-slot:error>
                <div
                   v-if="submittedWithErrors && !validField(fuelTransactionForm.license_plate)"
                  class="invalid-feedback"
                  style="display: block;"
                >
                  Campo Obrigatório
                </div>
              </template>
            </base-input>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-control-label d-block">Data Utilização <span class="text-danger">*</span></label>
            <el-date-picker
              v-model="fuelTransactionForm.utilization_date"
              type="date"
              prefix-icon="fa fa-calendar"
              format="d 'de' MMMM 'de' yyyy"
              rules="required"
              :editable="true"
              value-format="yyyy-MM-dd"
            />
            <div
              v-if="submittedWithErrors && !validField(fuelTransactionForm.utilization_date)"
              class="invalid-feedback"
              style="display: block;"
            >
              Campo Obrigatório
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label class="form-control-label d-block">Motorista <span class="text-danger">*</span></label>
            <multiselect
              v-model="fuelTransactionForm.driver"
              :options="users.map((user) => user.name)"
              placeholder="Selecionar Motorista"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
            />
            <div
              v-if="submittedWithErrors && !validField(fuelTransactionForm.driver)"
              class="invalid-feedback"
              style="display: block;"
            >
              Campo Obrigatório
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label class="form-control-label d-block">Tipo de Combustível <span class="text-danger">*</span></label>
            <multiselect
              v-model="fuelTransactionForm.fuel_type"
              :options="fuelTypes"
              placeholder="Selecionar Tipo de Compustível"
              :select-label="''"
              :deselect-label="''"
              :selected-label="'Selecionado'"
            />
            <div
              v-if="submittedWithErrors && !validField(fuelTransactionForm.fuel_type)"
              class="invalid-feedback"
              style="display: block;"
            >
              Campo Obrigatório
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <base-input
              v-model="fuelTransactionForm.volume"
              placeholder=""
              label="Quantidade (L)"
              mask="integer"
              @input="updateCalculatedFields()"
              :required="true"
            >
              <template v-slot:error>
                <div
                   v-if="submittedWithErrors && !validField(fuelTransactionForm.volume)"
                  class="invalid-feedback"
                  style="display: block;"
                >
                  Campo Obrigatório
                </div>
              </template>
            </base-input>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <base-input
              v-model="fuelTransactionForm.unitary_value"
              placeholder=""
              label="Valor Unitário"
              mask="money"
              @input="updateCalculatedFields()"
              :required="true"
            >
              <template v-slot:error>
                <div
                   v-if="submittedWithErrors && !validField(fuelTransactionForm.unitary_value)"
                  class="invalid-feedback"
                  style="display: block;"
                >
                  Campo Obrigatório
                </div>
              </template>
            </base-input>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <base-input
             v-model="fuelTransactionForm.pedometer_before"
              placeholder=""
              mask="integer"
              label="Odômetro Antes"
              @input="validatePedometer(); updateCalculatedFields()"
              :required="true"
            >
              <template v-slot:error>
                <div
                   v-if="submittedWithErrors && !validField(fuelTransactionForm.pedometer_before)"
                  class="invalid-feedback"
                  style="display: block;"
                >
                  Campo Obrigatório
                </div>
              </template>
            </base-input>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <base-input
              v-model="fuelTransactionForm.pedometer"
              placeholder=""
              label="Odômetro"
              mask="integer"
              @input="validatePedometer(); updateCalculatedFields()"
              :required="true"
            >
              <template v-slot:error>
                <div
                  v-if="!validPedometer"
                  class="invalid-feedback"
                  style="display: block;"
                >
                  Não pode ser menor que o Odômetro Antes
                </div>
                <div
                   v-if="submittedWithErrors && !validField(fuelTransactionForm.pedometer)"
                  class="invalid-feedback"
                  style="display: block;"
                >
                  Campo Obrigatório
                </div>
              </template>
            </base-input>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <base-input
              :value="fuelTransactionForm.total_value || 0"
              placeholder=""
              label="Valor Total"
              mask="money"
              :disabled="true"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <base-input
              :value="fuelTransactionForm.km_traveled || 0"
              placeholder=""
              label="Km Percorridos"
              mask="integer"
              :disabled="true"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <base-input
              :value="(fuelTransactionForm.average || 0)"
              placeholder=""
              label="Média Efetiva de Consumo"
              mask="volume"
              :disabled="true"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <base-input
              :value="(fuelTransactionForm.cost_per_km || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 })"
              placeholder=""
              label="Custo Por KM"
              :disabled="true"
            />
          </div>
        </div>
      </div>
      <div class="float-right">
        <base-button type="secondary" class="mr-2" @click="close">Fechar</base-button>
        <base-button type="success" @click="save">Salvar</base-button>
      </div>
    </form>
  </validation-observer>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";


import { ValidationProvider } from "vee-validate";
import { DatePicker } from "element-ui";

export default {
  components: {
    Multiselect,
    ValidationProvider,
    [DatePicker.name]: DatePicker,
  },
  props: {
    fuelTransaction: Object,
  },
  data() {
    return {
      users: [],
      filterData: null,
      pedometer_before: '',
      fuelTransactions: [],
      validFuelType: true,
      validPedometer: true,
      fuelTypes: [
        "GASOLINA COMUM",
        "GASOLINA ADITIVA",
        "GASOLINA PREMIUM",
        "DIESEL COMUM",
        "DIESEL S10",
        "DIESEL ADITIVADO",
        "DIESEL PREMIUM",
        "ETANOL COMUM",
      ],
      submittedWithErrors: false,
    };
  },
  mounted() {
    this.getFuelTransaction();
    this.getUsers();
  },
  computed: {
    fuelTransactionForm: {
      get: function () {
        return this.fuelTransaction || {};
      },
      set: function (newValue) {
        this.$emit("update:fuelTransaction", newValue);
      },
    },
  },
  methods: {
    validField(value) {
      if (typeof value != "object")  return !!value;
      if (!value) return false;
      if (value instanceof(Date)) return true;
      if (Object.keys(value).length == 0) return false;

      return true;
    },
    validatePresenceFields() {
      let validableData = {
        utilizationDate: this.fuelTransactionForm.utilization_date, driver: this.fuelTransactionForm.driver,
        pedometer: this.fuelTransactionForm.pedometer, pedometerBefore: this.fuelTransactionForm.pedometer_before,
        fuelType: this.fuelTransactionForm.fuel_type, volume: this.fuelTransactionForm.volume,
        unitaryValue: this.fuelTransactionForm.unitary_value
      }

      for (const validableDataKey in validableData) {
        if (!this.validField(validableData[validableDataKey])) {
          return false;
        }
      }

      return true;
    },
    validForm() {
      return this.validatePresenceFields() &&
             this.validatePedometer();
    },
    validatePedometer() {
      if (parseInt(this.unmask(this.fuelTransactionForm.pedometer_before)) > parseInt(this.unmask(this.fuelTransactionForm.pedometer))) return this.validPedometer = false;

      this.validPedometer = true;

      return this.validatePedometer
    },
    unmask(value){
      const middleValue = value.toString().replace(".", '').replace(",", '.');

      return middleValue;
    },
    close() {
      this.$emit("close")
    },
    getFuelTransaction() {
      this.$http.secured
        .get("/api/v1/fuel_transactions")
        .then((response) => {
          this.fuelTransactions = response.data;
        });
    },
    getUsers() {
      this.$http.secured
        .get(`/api/v1/users`, { params: { name_only: true } })
        .then((response) => {
          this.users = response.data;
        })
        .catch((error) => {
          // this.$toasted.global.defaultError();
        });
    },
    save() {
      if (!this.validForm()) {
        this.submittedWithErrors = true
        this.$toasted.global.defaultWarnig({
          msg: "Necessário preencher campos obrigatórios",
        })

        return;
      }

      if (this.fuelTransactionForm.id) {
        this.$http.secured
          .patch(`/api/v1/fuel_transactions/${this.fuelTransactionForm.id}`, {
            fuel_transaction: this.fuelTransactionForm,
          })
          .then((response) => {
            this.$toasted.global.defaultSuccess({msg: "Salvo com sucesso!"});
            this.$emit("save");
            this.fuelTransactionForm = {}
            this.submittedWithErrors = false
          })
          .catch((error) => {
            // this.$toasted.global.defaultError()
          });

        return;
      }

      this.$http.secured
        .post(`/api/v1/fuel_transactions`, {fuel_transaction: this.fuelTransactionForm})
        .then(() => {
          this.$toasted.global.defaultSuccess({msg: "Salvo com sucesso!"});
          this.$emit("save");
        })
        .catch((error) => {
          // this.$toasted.global.defaultError()
        });
    },
    updateCalculatedFields() {
      this.calculateKmTraveled();
      this.calculateKmCost();
      this.calculateAverageConsumption();
      this.calculateTotalValue();
    },
    calculateKmCost() {
      if (!this.fuelTransactionForm.total_value || !this.fuelTransactionForm.km_traveled) return;

      var kmCost = this.fuelTransactionForm.total_value / this.fuelTransactionForm.km_traveled;

      this.fuelTransactionForm.cost_per_km = kmCost;
    },
    calculateAverageConsumption() {
      if (!this.fuelTransactionForm.km_traveled || !this.fuelTransactionForm.volume) return;

      var kmConsuption = this.fuelTransactionForm.km_traveled / this.fuelTransactionForm.volume;

      this.fuelTransactionForm.average = kmConsuption;
    },
    calculateKmTraveled() {
      if (!this.fuelTransactionForm.pedometer || !this.fuelTransactionForm.pedometer_before) return;

      if (this.fuelTransactionForm.pedometer < this.fuelTransactionForm.pedometer_before) {
        this.fuelTransactionForm.km_traveled = 0
        return;
      }

      var kmTraveled = this.fuelTransactionForm.pedometer - this.fuelTransactionForm.pedometer_before;

      this.fuelTransactionForm.km_traveled = kmTraveled;
    },
    calculateTotalValue() {
      if (!this.fuelTransactionForm) return;
      if (!(this.fuelTransactionForm.unitary_value && this.fuelTransactionForm.volume)) return;

      var totalValue = this.fuelTransactionForm.unitary_value * this.fuelTransactionForm.volume;

      this.fuelTransactionForm.total_value = totalValue;
    },
    async getPedometerData(query = '') {
      try {
        const response = await this.$http.secured.get(`/api/v1/fuel_transactions`, {
          params: {
            filter: {
              license_plate: query,
            },
            order_by: 'utilization_date',
            order_sort: 'desc',
            per_page: 1,
          }
        })

        if (response.data.fuel_transactions.length == 0) return

        const lastTransaction = response.data.fuel_transactions[0]

        if (!lastTransaction) return;

        this.$set(this.fuelTransactionForm, "pedometer_before", lastTransaction.pedometer)

      } catch (error) {
        console.error('Error on fuel_transactions retrieval', error)
      }
    }
  },
  watch: {
    'fuelTransactionForm.license_plate': function (license_plate){
      if (!license_plate) return

      license_plate = license_plate.toUpperCase();
      this.getPedometerData(license_plate)
    }
  }
};
</script>
